const VALID_RATINGS = new Set(['positive', 'negative', 'concern'])

/** Feedback state for an alert row (positive / negative / concern / none). */
export function alertFeedbackState(item) {
  const feedback = item && item.feedback
  if (feedback == null || String(feedback).trim() === '')
    return 'none'
  const normalized = String(feedback).trim().toLowerCase()
  if (VALID_RATINGS.has(normalized))
    return normalized
  return 'none'
}

export function matchesAlertFeedbackFilter(item, selectedFeedback) {
  if (!selectedFeedback)
    return true
  return alertFeedbackState(item) === selectedFeedback
}

export function countAlertFeedback(items, state) {
  return (items || []).filter(item => alertFeedbackState(item) === state).length
}

/** Hover help for feedback filter chips on the Alert History page. */
export const ALERT_FEEDBACK_FILTER_TOOLTIPS = {
  group: 'Filter the table by team feedback on alerts. Counts reflect the current date range and type filters (before the feedback filter is applied).',
  positive: 'Show alerts marked as correct or acceptable. Click the chip to filter; click again to clear.',
  negative: 'Show alerts marked as incorrect or not usable. Click the chip to filter; click again to clear.',
  concern: 'Show alerts flagged with a concern and optional comment. Click the chip to filter; click again to clear.',
  none: 'Show alerts with no feedback yet. Click the chip to filter; click again to clear.',
  clear: 'Remove all feedback ratings and comments for every alert in the current date range.',
}
